import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bill-range',
  templateUrl: './bill-range.component.html',
  styleUrls: [],
  standalone: false
})
export class BillRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
